(() => {
  const launcher = document.getElementById('diggn-chat-button');
  const dialog = document.getElementById('diggn-chat-container');
  const closeButton = dialog?.querySelector('[data-diggn-concierge-close]');
  const frameHost = dialog?.querySelector('[data-diggn-concierge-frame]');

  if (!launcher || !dialog || !closeButton || !frameHost) return;

  const supportOrigin = dialog.dataset.supportOrigin;
  const supportPath = dialog.dataset.supportPath || '/chatbot-embed';
  const initialLocale = new URL(supportPath, supportOrigin).searchParams.get('locale') === 'ar' ? 'ar' : 'en';
  const mobileQuery = window.matchMedia('(max-width: 749px)');
  const mobileMode = launcher.dataset.mobileMode || 'inline';
  const allowedPageTypes = new Set([
    '404',
    'article',
    'blog',
    'cart',
    'collection',
    'index',
    'page',
    'password',
    'policy',
    'product',
    'search',
  ]);
  const pageType = allowedPageTypes.has(launcher.dataset.pageType)
    ? launcher.dataset.pageType
    : 'other';
  const invitationCopy = initialLocale === 'ar'
    ? {
        message: 'محتار وش يناسبك؟ أساعدك تختار.',
        mobileMessage: 'محتار وش يناسبك؟ اسألني.',
        openLabel: 'افتح مستشار العناية لمساعدتك في الاختيار',
        dismissLabel: 'إخفاء رسالة مستشار العناية',
      }
    : {
        message: 'Not sure what fits? I can help you choose.',
        mobileMessage: 'Need help choosing? Ask me.',
        openLabel: 'Open the grooming concierge for help choosing',
        dismissLabel: 'Dismiss the concierge invitation',
      };
  const invitation = document.createElement('div');
  const invitationMessage = document.createElement('button');
  const invitationClose = document.createElement('button');

  invitation.className = 'diggn-concierge-invitation';
  invitation.dataset.mobileMode = launcher.dataset.mobileMode || 'inline';
  invitation.hidden = true;
  invitationMessage.className = 'diggn-concierge-invitation__message';
  invitationMessage.type = 'button';
  invitationMessage.setAttribute('aria-label', invitationCopy.openLabel);
  invitationClose.className = 'diggn-concierge-invitation__close';
  invitationClose.type = 'button';
  invitationClose.textContent = '×';
  invitationClose.setAttribute('aria-label', invitationCopy.dismissLabel);
  invitation.append(invitationMessage, invitationClose);
  launcher.insertAdjacentElement('beforebegin', invitation);

  dialog.dataset.conciergeLocale = initialLocale;
  let iframe = null;
  let previouslyFocused = null;
  let invitationShown = false;
  let invitationAutoHideTimer = null;
  let invitationHideTimer = null;
  let mobileObstructionFrame = null;

  const invitationSessionKey = 'diggn_concierge_invitation_seen_v1';
  const invitationDelayMs = 10000;
  const invitationAutoHideMs = 10000;
  const invitationScrollThreshold = 0.4;
  const invitationMinimumDelayMs = 5000;
  const invitationStartedAt = Date.now();

  const analyticsAllowed = () => {
    try {
      return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
    } catch {
      return false;
    }
  };

  const measure = (eventName, detail = {}) => {
    const payload = {
      event: eventName,
      page_type: pageType,
      ...detail,
    };

    document.dispatchEvent(new CustomEvent('diggn:track', { detail: payload }));
    if (analyticsAllowed()) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
    }
  };

  const invitationWasSeen = () => {
    try {
      return window.sessionStorage.getItem(invitationSessionKey) === '1';
    } catch {
      return invitationShown;
    }
  };

  const markInvitationSeen = () => {
    try {
      window.sessionStorage.setItem(invitationSessionKey, '1');
    } catch {
      // Session storage can be unavailable in privacy-restricted browsers.
    }
  };

  const isMobileTeaser = () => mobileQuery.matches && mobileMode === 'teaser';

  const updateInvitationMessage = () => {
    invitationMessage.textContent = isMobileTeaser()
      ? invitationCopy.mobileMessage
      : invitationCopy.message;
  };

  const isVisibleBottomControl = (element) => {
    if (!element || !isMobileTeaser()) return false;
    if (
      element === launcher
      || element === invitation
      || element === dialog
      || element.closest?.(
        '.diggn-concierge-launcher, .diggn-concierge-invitation, .diggn-concierge-dialog, [data-global-mobile-utility], #PBarNextFrameWrapper'
      )
    ) {
      return false;
    }

    const styles = window.getComputedStyle(element);
    if (
      styles.display === 'none'
      || styles.visibility === 'hidden'
      || (styles.position !== 'fixed' && styles.position !== 'sticky')
    ) {
      return false;
    }

    const bounds = element.getBoundingClientRect();
    if (bounds.width < 36 || bounds.height < 30) return false;
    if (bounds.bottom < window.innerHeight - 24 || bounds.top < window.innerHeight * 0.35) return false;

    const isWide = bounds.width >= window.innerWidth * 0.45;
    const isNearInlineEnd = initialLocale === 'ar'
      ? bounds.left <= 96
      : bounds.right >= window.innerWidth - 96;

    return isWide || isNearInlineEnd;
  };

  const hasMobileObstruction = () => {
    if (!isMobileTeaser() || !dialog.hidden) return false;

    const knownControls = Array.from(
      document.querySelectorAll(
        '#shopify-pc__banner, [data-shopify-privacy-banner], #appstle_loyalty_points_float, #appstle_widget, [id*="loyal"], [class*="loyal"], [id*="reward"], [class*="reward"]'
      )
    );
    if (knownControls.some(isVisibleBottomControl)) return true;

    return Array.from(document.body.children).some(isVisibleBottomControl);
  };

  const syncMobileObstruction = () => {
    mobileObstructionFrame = null;
    const isObstructed = hasMobileObstruction();
    launcher.classList.toggle('is-mobile-obstructed', isObstructed);
    invitation.classList.toggle('is-mobile-obstructed', isObstructed);
  };

  const scheduleMobileObstructionSync = () => {
    if (mobileObstructionFrame) return;
    mobileObstructionFrame = window.requestAnimationFrame(syncMobileObstruction);
  };

  const launcherIsVisible = () => {
    const styles = window.getComputedStyle(launcher);
    const bounds = launcher.getBoundingClientRect();
    return (
      styles.display !== 'none'
      && styles.visibility !== 'hidden'
      && bounds.width > 0
      && bounds.height > 0
    );
  };

  const clearInvitationAutoHide = () => {
    if (!invitationAutoHideTimer) return;
    window.clearTimeout(invitationAutoHideTimer);
    invitationAutoHideTimer = null;
  };

  const finishInvitationHide = () => {
    if (invitationHideTimer) {
      window.clearTimeout(invitationHideTimer);
      invitationHideTimer = null;
    }
    invitation.hidden = true;
  };

  const hideInvitation = (reason, restoreLauncherFocus = false, recordDismissal = false) => {
    if (invitation.hidden) return;

    clearInvitationAutoHide();
    invitation.classList.remove('is-visible');
    invitationHideTimer = window.setTimeout(finishInvitationHide, 180);

    if (recordDismissal) {
      measure('concierge_invitation_dismiss', { reason });
    }

    if (restoreLauncherFocus) {
      window.requestAnimationFrame(() => launcher.focus({ preventScroll: true }));
    }
  };

  const showInvitation = (trigger) => {
    syncMobileObstruction();
    if (
      invitationShown
      || invitationWasSeen()
      || !dialog.hidden
      || document.visibilityState !== 'visible'
      || !launcherIsVisible()
    ) {
      return false;
    }

    invitationShown = true;
    markInvitationSeen();
    invitation.hidden = false;
    window.requestAnimationFrame(() => invitation.classList.add('is-visible'));
    measure('concierge_invitation_view', { trigger });
    invitationAutoHideTimer = window.setTimeout(
      () => hideInvitation('timeout', false, true),
      invitationAutoHideMs
    );
    return true;
  };

  const requestInvitation = (trigger) => {
    const remainingDelay = invitationMinimumDelayMs - (Date.now() - invitationStartedAt);
    if (remainingDelay > 0) {
      window.setTimeout(() => showInvitation(trigger), remainingDelay);
      return;
    }
    showInvitation(trigger);
  };

  const ensureIframe = () => {
    if (iframe) return iframe;

    const iframeUrl = new URL(supportPath, supportOrigin);
    iframeUrl.searchParams.set('host', 'shopify');
    iframe = document.createElement('iframe');
    iframe.src = iframeUrl.toString();
    iframe.title = dialog.dataset.iframeTitle || "Diggn'It Grooming Concierge";
    iframe.loading = 'lazy';
    iframe.referrerPolicy = 'strict-origin-when-cross-origin';
    iframe.allow = 'autoplay; clipboard-write';
    frameHost.appendChild(iframe);
    return iframe;
  };

  const closeDialog = () => {
    if (dialog.hidden) return;
    if (iframe?.contentWindow) {
      iframe.contentWindow.postMessage(
        { type: 'concierge:host-close' },
        supportOrigin
      );
    }
    dialog.hidden = true;
    launcher.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('diggn-concierge-is-open');
    measure('concierge_close');
    (previouslyFocused || launcher).focus({ preventScroll: true });
  };

  const openDialog = (source = 'floating_launcher') => {
    if (!dialog.hidden) return;
    previouslyFocused = source === 'proactive_invite'
      || source === 'mobile_teaser'
      || source === 'mobile_portrait'
      || source === 'floating_launcher'
      ? launcher
      : document.activeElement instanceof HTMLElement
        ? document.activeElement
        : launcher;
    markInvitationSeen();
    hideInvitation('opened');
    ensureIframe();
    dialog.hidden = false;
    launcher.setAttribute('aria-expanded', 'true');
    document.body.classList.add('diggn-concierge-is-open');
    measure('concierge_open', { source });
    closeButton.focus({ preventScroll: true });
  };

  launcher.addEventListener('click', () => {
    if (dialog.hidden) openDialog(isMobileTeaser() ? 'mobile_portrait' : 'floating_launcher');
    else closeDialog();
  });

  invitationMessage.addEventListener('click', () => {
    openDialog(isMobileTeaser() ? 'mobile_teaser' : 'proactive_invite');
  });

  invitationClose.addEventListener('click', () => {
    hideInvitation('manual', true, true);
  });

  invitation.addEventListener('pointerenter', clearInvitationAutoHide);
  invitation.addEventListener('focusin', clearInvitationAutoHide);

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest?.('[data-diggn-open-support]');
    if (!trigger) return;
    event.preventDefault();

    const headerDrawer = trigger.closest('header-drawer');
    const drawerSummary = headerDrawer?.querySelector('details > summary');
    if (headerDrawer?.closeMenuDrawer && drawerSummary) {
      headerDrawer.closeMenuDrawer(event, drawerSummary);
    }

    openDialog('inline_recommendation');
  });

  closeButton.addEventListener('click', closeDialog);

  document.addEventListener('diggn:open-support', () => openDialog('custom_event'));

  document.addEventListener('keydown', (event) => {
    if (dialog.hidden) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      closeDialog();
      return;
    }

    if (event.key !== 'Tab') return;

    const focusable = Array.from(
      dialog.querySelectorAll('button:not([disabled]), iframe, [href], [tabindex]:not([tabindex="-1"])')
    ).filter((element) => !element.hasAttribute('hidden'));

    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  window.addEventListener('message', (event) => {
    if (event.origin !== supportOrigin) return;
    if (!iframe || event.source !== iframe.contentWindow) return;
    if (!event.data || typeof event.data !== 'object') return;
    if (event.data.type === 'chatbot:close') closeDialog();
    if (
      event.data.type === 'concierge:locale'
      && (event.data.locale === 'en' || event.data.locale === 'ar')
    ) {
      dialog.dataset.conciergeLocale = event.data.locale;
    }
  });

  if (!invitationWasSeen()) {
    window.setTimeout(() => showInvitation('delay'), invitationDelayMs);

    const handleInvitationScroll = () => {
      const scrollableHeight = document.documentElement.scrollHeight - window.innerHeight;
      if (scrollableHeight <= 0) return;
      const scrollProgress = window.scrollY / scrollableHeight;
      if (scrollProgress < invitationScrollThreshold) return;

      window.removeEventListener('scroll', handleInvitationScroll);
      requestInvitation('scroll');
    };

    window.addEventListener('scroll', handleInvitationScroll, { passive: true });
  }

  window.addEventListener('resize', () => {
    updateInvitationMessage();
    scheduleMobileObstructionSync();
    if (!invitation.hidden && !launcherIsVisible()) {
      hideInvitation('launcher_hidden');
    }
  }, { passive: true });

  window.addEventListener('orientationchange', scheduleMobileObstructionSync, { passive: true });
  new MutationObserver(scheduleMobileObstructionSync).observe(document.body, {
    childList: true,
    subtree: true,
  });
  window.setTimeout(scheduleMobileObstructionSync, 1000);
  window.setTimeout(scheduleMobileObstructionSync, 3000);
  updateInvitationMessage();
  syncMobileObstruction();
})();
